import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS,
  getFontContrastColor
} from '../../../themes'
const Style = styled.div`
  z-index: ${Z_INDEXS.LV_MAX};
  width: 100%;
  height: 100%;
  background-color: #000000AA;
  position: fixed;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  scroll-behavior: smooth;
  top: 0;
  left: 0;
  .modal-container {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    height: 520px;
    width: 780px;
    padding: 32px;
    box-sizing: border-box;
    background-color: ${COLOR.WHITE};
    border-radius: 8px;
    animation-timing-function: ease-out;
    animation-duration: 200ms;
    animation-name: modal-animation;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  .modal-container > * {
    margin: 8px 0;
    opacity: inherit;
  }
  .menu-container {
    position: relative;
    margin: 0 0 8px 0;
    padding: 0;
    min-width: 100%;
    max-width: 100%;
    width: 100%;
  }
  .menu-container > *:first-child {
    margin: 0 6px 0 0;
  }
  .order-container {
    padding: 8px 0 8px 0;
    height: auto;
    min-height: 22px;
    max-height: 22px;
    overflow-y: hidden;
    overflow-x: hidden;
    transition: none;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
  }
  .order-container.show {
    min-height: unset;
    max-height: 1000px;
    transition: max-height 100ms ease-out, overflow-y 0ms linear 100ms, padding 100ms ease-out;
  }
  .order-container.show > * > * > img.icon-btn {
    transform: rotate(180deg);
  }
  .order-container > * {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .order-container > *:first-child {
    margin-bottom: 12px;
  }
  .order-item {
    margin: 0 0 0 28px;
  }
  .item-container {
    margin: 4px 0;
    min-height: 34px;
  }

  .row-order {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
  }

  .list-container {
    margin: 0;
  }
  .order-header {
    color: ${COLOR.BLACK_1};
    font-weight: normal;
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: stretch;
  }
  .order-header > .Waiting {
    color: ${COLOR.BLACK_1};
  }
  .order-header > .Completed {
    color: ${COLOR.BLACK_1};
  }
  .order-header > *:not(:last-child) {
    min-width: 200px;
  }
  .header-text {
    flex: 0;
    text-align: center;
    color: black;
    padding: 6px;
    margin: 8px;
    font-size: ${FONT_SIZE.SM};
  }
  .active-menu {
    cursor: pointer;
    font-size: ${FONT_SIZE.XXS};
    margin-right: 30px;
    float: left;
    color: ${COLOR.BLACK_1};
    font-weight: bold;
  }
  .active-border-menu{
    position: absolute;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    z-index: ${Z_INDEXS.LV_1};
    left: 0;
    right: 0;
    border: 2px solid transparent;
    -webkit-border-top-left-radius: 10px;
    -webkit-border-top-right-radius: 10px;
    -moz-border-radius-topleft: 10px;
    -moz-border-radius-topright: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .menu,
  .active-menu {
    margin: 0;
    flex: 1;
    float: none;
    align-self: flex-start;
  }
  .head-page {
    font-size: ${FONT_SIZE.TN};
  }
  .top-menu {
    position: relative;
    line-height: 36px;
    border: none;
    z-index: ${Z_INDEXS.LV_2};
    margin-bottom: 0;
    height: auto;
    float: left;
  }
  .top-menu,
  .top-menu * {
    cursor: pointer;
  }
  hr.header-line {
    position: absolute;
    margin: 0;
    padding: 0;
    border: 1px solid ${COLOR.GRAY_1};
    color: ${COLOR.GRAY_1};
    background-color: ${COLOR.GRAY_1};
    width: 100%;
    z-index: ${Z_INDEXS.LV_0};
    top: 38px;
  }
  .catering-btn {
    margin: 0;
    padding: 0;
    line-height: unset;
    height: 26px;
    width: 26px;
  }
  .catering-btn:hover {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .catering-btn:active {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .catering-btn:focus {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }
  .count-unit {
    margin: 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    min-width: 2em;
    text-align: center;
  }
  .btn {
    margin-top: 40px;
    width: 196px;
    margin: 0;
    font-size: ${FONT_SIZE.XXS};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    border: 1px solid ${COLOR.GRAY_6};
    background: ${COLOR.WHITE};
    float: none;
    color: ${COLOR.BLACK_1};
  }
  .btn-cancel {
    border: 1px solid ${COLOR.BLACK_1};
    background: ${COLOR.BLACK_1};
    margin-left: 10px;
    color: ${COLOR.WHITE};
  }
  .btn-save,
  .btn-save-pass {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    margin-left: 10px;
    color: ${({ colorTheme }) => colorTheme ? getFontContrastColor(colorTheme) : COLOR.BLACK_1};
  }
  .btn.btn-save-pass {
    font-size: ${FONT_SIZE.XXS};
  }
  .btn:disabled {
    opacity: 0.2;
    cursor: not-allowed !important;
  }
  .icon-btn {
    height: ${FONT_SIZE.MD};
    width: ${FONT_SIZE.MD};
  }
  hr.seperator {
    margin: 12px 0 4px 0;
    align-self: center;
    width: calc(100% - 64px);
  }
  hr.gap {
    margin: 2px 0;
    align-self: center;
    width: 100%;
    opacity: 0;
  }
  .dropdown-btn {
    position: absolute;
    right: 0;
    top: unset;
  }
  .flex-start {
    align-items: flex-start !important;
  }
  .self-flex-start {
    align-self: flex-start !important;
  }
  .space-between {
    justify-content: space-between !important;
  }
  .space-evenly {
    justify-content: space-evenly !important;
  }
  .space-around {
    justify-content: space-around !important;
  }
  .flex-zero {
    flex: 0 !important;
  }
  .flex-one {
    flex: 1 !important;
  }
  .flex-two {
    flex: 2 !important;
  }
  .full-width {
    width: 100%;
  }
  .full-height {
    height: 100%;
  }
  .overflowX-scroll {
    overflow-x: scroll;
  }
  .overflowY-scroll {
    overflow-y: scroll;
  }
  .align-center {
    align-self: center !important;
  }
  .error{
    border: 1px solid ${COLOR.RED_2} !important;
  }
  .error-text{
    color: ${COLOR.RED_2} !important;
  }
  .padding-right-34 {
    padding-right: 34px;
  }
  .margin-left-6 {
    margin-left: 6px;
  }
  .no-margin-x-right {
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
  .color-black {
    color: ${COLOR.BLACK_1} !important;
  }
  .position-relative {
    position: relative !important;
  }
  .hidden-overflow {
    overflow: hidden !important;
  }
  .text-ellipsis {
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
  }
  .flex-horizontal > .field-input {
    flex: 3;
    margin: 0 32px 0 0;
    padding: 0;
    width: auto;
    outline: none;
    cursor: pointer;
    min-height: ${FONT_SIZE.XXXL}
  }
  .flex-horizontal > p {
    margin: 0 32px 0 0;
  }
  .flex-vertical {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
  }
  .flex-horizontal {
    display: flex;
    flex-flow: row nowrap;
    justify-content: stretch;
    align-items: center;
  }
  @keyframes modal-animation {
    0% {
      max-width: 400px;
      opacity: 0.5;
    }
    100% {
      max-width: 900px;
      opacity: 1;
    }
  }
`

export default Style
